// extracted by mini-css-extract-plugin
module.exports = {"topTip":"antd-pro-components-authorized-perfect-admin-phone-topTip"};